import moment from 'moment'

// 是否二级医院
function isSecondaryHospital () {
  return ['fuyou'].includes(process.env.HOSPITAL)
}

function getBASE64 (dataArray) {
  let digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  let strData = ''
  for (let i = 0, ii = dataArray.length; i < ii; i += 3) {
    if (isNaN(dataArray[i])) break
    let b1 = dataArray[i] & 0xFF
    let b2 = dataArray[i + 1] & 0xFF
    let b3 = dataArray[i + 2] & 0xFF
    let d1 = b1 >> 2
    let d2 = ((b1 & 3) << 4) | (b2 >> 4)
    let d3 = i + 1 < ii ? ((b2 & 0xF) << 2) | (b3 >> 6) : 64
    let d4 = i + 2 < ii ? (b3 & 0x3F) : 64
    strData += digits.substring(d1, d1 + 1) + digits.substring(d2, d2 + 1) + digits.substring(d3, d3 + 1) + digits.substring(d4, d4 + 1)
  }
  return strData
}

// 将Base64数据转换为Blob对象
function base64ToBlob (base64Data, contentType) {
  const byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i))
  const byteArray = new Uint8Array(byteNumbers)
  return new Blob([byteArray], { type: contentType })
}

// 下载文件
function downloadFile (base64Data, fileName, contentType) {
  const blob = base64ToBlob(base64Data, contentType)
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function formatChineseDate (_date) {
  let date = new Date(_date)
  let year = date.getFullYear() + ''
  let month = date.getMonth() + 1 // 由于月份的范围是0~11，所以这里提出的月份需要+1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  function constant (number) {
    let arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    if (number < 10) {
      return arr[number]
    } else if (number % 10 === 0) {
      // 如果是整十数，且十位数是1，则直接返回"十"而不是"一十"
      if (number === 10) {
        return '十'
      } else {
        return arr[number / 10] + '十'
      }
    } else {
      let ge = number % 10
      let shi = parseInt(number / 10)
      // 如果十位数是1，则不显示"一"，直接显示"十"
      if (shi === 1) {
        return '十' + arr[ge]
      } else {
        return arr[shi] + '十' + arr[ge]
      }
    }
  }

  let yearStr = ''
  for (let i = 0; i < year.length; i++) {
    yearStr += constant(year[i])
  }

  let monthStr = constant(month)
  let dayStr = constant(day)
  let hoursStr = constant(hours)
  let minutesStr = constant(minutes)
  let secondsStr = constant(seconds)

  return {
    yearStr,
    monthStr,
    dayStr,
    hoursStr,
    minutesStr,
    secondsStr
  }

  // console.log('现在是' + yearStr + '年' + monthStr + '月' + dayStr + '日 ' + hoursStr + '时' + minutesStr + '分' + secondsStr + '秒')
}

/**
 * 根据时间查询相近的小时并生成对应时间
 * @param {string} time - 输入时间字符串 格式: 'YYYY/MM/DD HH:mm:ss'
 * @param {number[]} hourArray - 小时数组，默认为 [2, 6, 10, 14, 18, 22]
 * @returns {string} 返回最接近小时的时间字符串
 */
function findClosestHourTime (time, hourArray = [2, 6, 10, 14, 18, 22]) {
  // 使用moment解析时间并获取小时
  const timeMoment = moment(time, 'YYYY/MM/DD HH:mm:ss')
  const currentHour = timeMoment.hour()

  // 找到最接近的小时
  const closestHour = hourArray.reduce((closest, hour) => {
    return Math.abs(currentHour - hour) < Math.abs(currentHour - closest) ? hour : closest
  })

  // 生成结果时间
  return timeMoment.clone().hour(closestHour).minute(0).second(0).format('YYYY/MM/DD HH:mm:ss')
}

/**
 * 生成自定义格式的唯一标识符
 * @param {string} prefix - 前缀标识符
 * @param {number} length - 随机部分长度，默认为8
 * @param {string} format - 格式类型：'hex'(十六进制)、'num'(数字)、'mix'(混合)，默认为'hex'
 * @returns {string} 返回自定义格式的唯一标识符
 */
function generateCustomId (prefix = '', length = 8, format = 'hex') {
  let chars = ''
  let randomPart = ''

  switch (format) {
    case 'num':
      chars = '0123456789'
      break
    case 'mix':
      chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
      break
    case 'hex':
    default:
      chars = '0123456789ABCDEF'
      break
  }

  for (let i = 0; i < length; i++) {
    randomPart += chars.charAt(Math.floor(Math.random() * chars.length))
  }

  const timestamp = Date.now().toString(36).toUpperCase()
  return `${prefix ? prefix + '_' : ''}${timestamp}_${randomPart}`
}

function sleep (time) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export function padZero (value, length) {
  let str = String(value)
  while (str.length < length) {
    str = '0' + str
  }
  return str
}

export { isSecondaryHospital, getBASE64, downloadFile, formatChineseDate, findClosestHourTime, generateCustomId, sleep }
